















import { defineComponent, reactive } from '@vue/composition-api';

const Supplier = defineComponent({
  setup() {
    const filter = reactive({
      search: '',
    });

    return {
      filter,
    };
  },
});

export default Supplier;
